import {
  updateVisitorAttrsApi,
  getBlacklistSingleApi,
  addBlacklistApi,
  removeBlacklistApi,
  getAttrConfig,
  getCustomerQueryParams,
  editAttrConfig,
  addAttrConfig,
  addCustomerQueryParams,
  deleteCustomerQueryParams,
  editCustomerQueryParams,
  getCustomerList,
  getCustomerAttrs,
  exportCustomer,
  checkExportCustomerStatus,
  deleteCustomer,
  getCustomerDetail,
  editCustomerInfo,
  editCustomerName,
  addCustomerTag,
  deleteCustomerTag,
  getCustomerTimeline,
  getChangeLogList,
  getCustomerPages,
  getTrackEventList,
  getTrackEventSettingList,
  getTrackEventDetail,
  editTrackEventSetting
} from '../api/customer';

const eventOn = emitter => {
  emitter.promiseOn('updateVisitorAttrs', payload => {
    return updateVisitorAttrsApi(payload);
  });

  emitter.promiseOn('getBlacklistSingle', payload => {
    return getBlacklistSingleApi(payload);
  });

  emitter.promiseOn('addBlacklist', payload => {
    return addBlacklistApi(payload);
  });

  emitter.promiseOn('removeBlacklist', payload => {
    return removeBlacklistApi(payload);
  });

  emitter.promiseOn('getAttrConfig', payload => getAttrConfig(payload));

  emitter.promiseOn('editAttrConfig', payload => editAttrConfig(payload));

  emitter.promiseOn('getCustomerQueryParams', payload => getCustomerQueryParams(payload));

  emitter.promiseOn('addAttrConfig', payload => addAttrConfig(payload));

  emitter.promiseOn('addCustomerQueryParams', payload => addCustomerQueryParams(payload));

  emitter.promiseOn('deleteCustomerQueryParams', payload => deleteCustomerQueryParams(payload));

  emitter.promiseOn('editCustomerQueryParams', payload => editCustomerQueryParams(payload));

  emitter.promiseOn('getCustomerList', payload => getCustomerList(payload));

  emitter.promiseOn('getCustomerAttrs', payload => getCustomerAttrs(payload));

  emitter.promiseOn('exportCustomer', payload => exportCustomer(payload));

  emitter.promiseOn('checkExportCustomerStatus', payload => checkExportCustomerStatus(payload));

  emitter.promiseOn('deleteCustomer', payload => deleteCustomer(payload));

  emitter.promiseOn('getCustomerDetail', payload => getCustomerDetail(payload));

  emitter.promiseOn('editCustomerInfo', payload => editCustomerInfo(payload));

  emitter.promiseOn('editCustomerName', payload => editCustomerName(payload));
  emitter.promiseOn('addCustomerTag', payload => addCustomerTag(payload));
  emitter.promiseOn('deleteCustomerTag', payload => deleteCustomerTag(payload));
  emitter.promiseOn('getCustomerTimeline', payload => getCustomerTimeline(payload));
  emitter.promiseOn('getChangeLogList', payload => getChangeLogList(payload));
  emitter.promiseOn('getCustomerPages', payload => getCustomerPages(payload));
  emitter.promiseOn('getTrackEventList', payload => getTrackEventList(payload));
  emitter.promiseOn('getTrackEventSettingList', payload => getTrackEventSettingList(payload));
  emitter.promiseOn('getTrackEventDetail', payload => getTrackEventDetail(payload));
  emitter.promiseOn('editTrackEventSetting', payload => editTrackEventSetting(payload));
};

export default eventOn;
